import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import _ from "lodash";
import ApiDynamicSetting from "../../../core/api/api.dynamicSetting";
import { IconCall, IconLocation } from "../../../assets/icons";
// import { GeoAlt, Headset } from 'react-bootstrap-icons';

function ContactUs() {
  const [body, setBody] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        let response = await ApiDynamicSetting.getAboutUs();
        if (response.succeeded) {
          setBody(response.data.text);
        }
      } catch (error) {}
    })();
    return () => {};
  }, []);

  return (
    <>
      <Container fluid className=" bg-light-3">
        <Container className="py-4">
          <Row className=" px-3 py-4 bg-white rounded-4 mt-xl-3 mt-1 shadow-sm">
            <Col lg="8" className="">
              <div className="">
                <IconLocation fillColor="#000" />
                <span className="ms-1 fw-bold">آدرس</span>
              </div>
              <div className="mt-3 fs-09">
                جزیره کیش - بلوار میر مهنا - روبروی بازار پارس خلیج - مرکز
                نوآوری کیش - طبقه 4 - واحد 401 - شرکت رایان سفر نیکان کیش
              </div>
            </Col>
            <Col lg="4" className=" mt-5 mt-lg-0">
              <div className="">
                <IconCall fillColor="#000" />
                <span className="ms-1 fw-bold">تلفن ها </span>
              </div>
              <Row className="mt-3">
                <Col xs="12" lg="4" className="  ">
                  <a href="tel:07644100000" className="text-muted">
                    076-44100000
                  </a>
                </Col>
                <Col xs="12" lg="4" className="  ">
                  <a href="tel:09193373894" className="text-muted">
                    09193373894
                  </a>
                </Col>
                <Col xs="12" lg="4" className="  ">
                  <a href="tel:09199781891" className="text-muted">
                    09199781891
                  </a>
                </Col>
              </Row>
            </Col>
            <Row>
              <Col className="">
                <div style={{ fontSize: " 12px" }} className="mt-3">
                  <span>
                    جهت اطلاع از ساعت حرکت شناورها یا موارد دیگر مربوط به بندر
                    چارک و بندر آفتاب
                    <span
                      style={{ fontSize: " 14px", color: "red" }}
                      className="fw-bold"
                    >
                      {" "}
                      تماس
                      <span
                        style={{ fontSize: " 18px", color: "red" }}
                        className="fw-bold"
                      >
                        {" "}
                        نگیرید{" "}
                      </span>
                    </span>
                  </span>
                </div>
              </Col>
            </Row>
          </Row>

          <Row className=" px-3 py-4 bg-white rounded-4 mt-xl-3 mt-3 shadow-sm">
            <Col className="m-3">
              <div className=" d-flex justify-content-center mt-2">
                <span style={{ fontSize: "15px " }} className="fw-bold mr-2">
                  نماد اعتماد الکترونیکی از وزارت صنعت و معدن
                </span>
              </div>
              <div className=" d-flex justify-content-center">
                <div
                  className=" mt-3 "
                  style={{ width: "130px", height: "130px" }}
                >
                  <a
                    referrerPolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
                  >
                    <img
                      referrerPolicy="origin"
                      className=" img-fluid  w-100 h-100 "
                      src="https://Trustseal.eNamad.ir/logo.aspx?id=274889&amp;Code=A32132KLXam6f2jcPJyV"
                      style={{ cursor: "pointer" }}
                      id="A32132KLXam6f2jcPJyV"
                    />
                  </a>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="px-3 py-4 rounded-4 mt-xl-3 mt-3 shadow-sm bg-white">
            <Col className="py-3 px-2">
              <div className="fs-102 fw-bold">درباره تفریحان</div>
              <p className="text-align-justify mt-2 fs-09">
                مجموعه تفریحان مجموعه‌ای جوان و خلاق است که اقدام به ایجاد
                سامانه بومی برای رزرو تفریحات جزیره کیش با قیمت مناسب کرده است
                که شما می‌توانید در این سامانه علاوه بر مشاهده قیمت بروز هر
                تفریح، قوانین و اطلاعات هر تفریح، مشاهده عکس و کلیپ هر تفریح و
                وضعیت جوی جزیره کیش در هر زمان مشاهده نمایید. همچنین یکی دیگر از
                اهداف این مجموعه جلوگیری از سوءاستفاده‌های انجام شده توسط
                کلاهبرداران از مسافران جزیره کیش است که در این راستا اقدامات
                مؤثری انجام داده‌ایم. ما در مجموعه تفریحان در تلاش هستیم تا
                همواره بکوشیم که بهترین و سریع‌ترین خدمات را در هر ساعت از
                شبانه‌روز ارائه نماییم. رضایت مسافر از خدمات و همچنین جلوگیری از
                ایجاد مشکلات متعدد در زمان رزرو اولویت تفریحان می‌باشد و در این
                راه می‌کوشیم تا بهترین خود باشیم.
              </p>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
}
export default ContactUs;
